var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade-in" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        class: _vm.classes,
        style: _vm.outerStyles
      },
      [_c("div", { class: _vm.innerClasses, style: _vm.styles })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }